import { render, staticRenderFns } from "./CompCompanyData.vue?vue&type=template&id=1d6fe036&scoped=true"
import script from "./CompCompanyData.vue?vue&type=script&lang=js"
export * from "./CompCompanyData.vue?vue&type=script&lang=js"
import style0 from "./CompCompanyData.vue?vue&type=style&index=0&id=1d6fe036&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6fe036",
  null
  
)

export default component.exports